import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
var _excluded = ["children"];
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js/instance/starts-with";
import { Component, directClone, createVNode } from 'intact-react';
import { isTextChildren } from './utils';
import { EMPTY_OBJ, isFunction, hasOwn } from 'intact-shared';
import { cx } from '@emotion/css';
var reactEventReg = /on[A-Z]/;
export var Virtual = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Virtual, _Component);
  function Virtual() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.vNodeProps = null;
    return _this;
  }
  Virtual.template = function template() {
    var _cx;
    var _this$get = this.get(),
      children = _this$get.children,
      props = _objectWithoutPropertiesLoose(_this$get, _excluded);
    if (process.env.NODE_ENV !== 'production') {
      if (!children || Array.isArray(children) && children.length !== 1) {
        throw new Error('Component must receive one children');
      }
    }
    var vNode = Array.isArray(children) ? children[0] : children;
    var clonedVNode = isTextChildren(vNode) ? createVNode('span', null, vNode) : directClone(vNode);
    var vNodeProps = this.vNodeProps = this.getVNodeProps(clonedVNode.props || EMPTY_OBJ);
    var eventProps = this.getEventProps();
    //  merge className 
    var className = clonedVNode.className || vNodeProps.className;
    className = cx((_cx = {}, _cx[className] = !!className, _cx[props.className] = !!props.className, _cx));
    clonedVNode.props = _extends({}, props, vNodeProps, eventProps, {
      className: className
    });
    clonedVNode.className = className;
    return clonedVNode;
  };
  var _proto = Virtual.prototype;
  _proto.getVNodeProps = function getVNodeProps(props) {
    var vnode = props.vnode;
    if (!vnode) return props;
    // maybe we render the intact component in react slot property, in this case
    // the $isReact is false. so use the vnode $$typeof field as gauge
    if (vnode.$$typeof || vnode.__v_isVNode /* vue3 vnode */) {
      var _props = vnode.props;
      if (!_props) return props;
      var events = {};
      for (var key in _props) {
        if (reactEventReg.test(key)) {
          events["ev-" + key.substring(2).toLowerCase()] = _props[key];
        }
      }
      return _extends({}, props, events, {
        className: _props.className || _props.class /* vue-next */
      });
    } else if (hasOwn.call(vnode, 'componentOptions') /* vue2 vnode */) {
      var data = vnode.data;
      if (!data) return props;
      var on = data.on || EMPTY_OBJ;
      var _events = {};
      for (var _key2 in on) {
        _events["ev-" + _key2] = on[_key2];
      }
      return _extends({}, props, _events, {
        className: data.staticClass
      });
    }
    return props;
  };
  _proto.getEventProps = function getEventProps() {
    var _this2 = this;
    var props = {};
    var _loop = function _loop(prop) {
      if (_startsWithInstanceProperty(prop).call(prop, 'ev-')) {
        props[prop] = function (e) {
          return _this2.callEvent(prop, e);
        };
      }
    };
    for (var prop in this.get()) {
      _loop(prop);
    }
    return props;
  };
  _proto.callEvent = function callEvent(name, e) {
    var callback = this.vNodeProps[name];
    var callbackOnVirtual = this.get(name);
    if (isFunction(callback)) callback(e);
    if (isFunction(callbackOnVirtual)) callbackOnVirtual(e);
  };
  return Virtual;
}(Component);